import React, { useEffect, useState } from 'react';
import { Table, Form, Button, Modal } from 'react-bootstrap';
import axios from 'axios';

const AddSize = () => {
    const [sizes, setSizes] = useState([]);
    const [title, setTitle] = useState('');
    const [price, setPrice] = useState('');
    const [statusDesignInfoId, setStatusDesignInfoId] = useState('');
    const [statusDesignInfos, setStatusDesignInfos] = useState([]); // Store status design info options
    const [errorMessage, setErrorMessage] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [selectedSize, setSelectedSize] = useState(null);

    // Fetch all sizes and status design info on component mount
    useEffect(() => {
        fetchSizes();
        fetchStatusDesignInfos();
    }, []);

    const fetchSizes = async () => {
        try {
            const response = await axios.get('https://drdprints.com/api/get-staticdesigninfosizes');
            setSizes(response.data.design_info_sizes);
        } catch (error) {
            console.error('Error fetching sizes:', error);
        }
    };

    const fetchStatusDesignInfos = async () => {
        try {
            const response = await axios.get('https://drdprints.com/api/get-staticdesigninfo/1');
            setStatusDesignInfos(response.data.design_info || []); // Extract design info array from response
        } catch (error) {
            console.error('Error fetching status design info:', error);
        }
    };

    // Add new size
    const handleAddSize = async (e) => {
        e.preventDefault();
        try {
            const newSize = {
                title,
                price,
                status_design_info_id: statusDesignInfoId,
            };
            await axios.post('https://drdprints.com/api/store-staticdesigninfosizes', newSize);
            setTitle('');
            setPrice('');
            setStatusDesignInfoId('');
            setErrorMessage('');
            fetchSizes();
        } catch (error) {
            if (error.response && error.response.data.errors) {
                setErrorMessage(error.response.data.errors.status_design_info_id[0]);
            } else {
                console.error('Error adding size:', error);
            }
        }
    };

    // Delete size
    const handleDeleteSize = async (id) => {
        try {
            await axios.delete(`https://drdprints.com/api/deletestaticdesigninfosizes/${id}`);
            fetchSizes();
        } catch (error) {
            console.error('Error deleting size:', error);
        }
    };

    // Open modal for updating size
    const handleOpenUpdateModal = (size) => {
        setSelectedSize(size);
        setTitle(size.title);
        setPrice(size.price);
        setStatusDesignInfoId(size.status_design_info_id);
        setShowModal(true);
    };

    // Update size
    const handleUpdateSize = async () => {
        try {
            const updatedSize = {
                title,
                price,
                status_design_info_id: statusDesignInfoId,
            };
            await axios.put(`https://drdprints.com/api/update-staticdesigninfosizes/${selectedSize.id}`, updatedSize);
            setShowModal(false);
            setSelectedSize(null);
            fetchSizes();
        } catch (error) {
            console.error('Error updating size:', error);
        }
    };

    return (
        <div className="container mt-5">
            <h1>Add Size</h1>

            {/* Form to Add New Size */}
            <Form onSubmit={handleAddSize}>
                <Form.Group controlId="formTitle">
                    <Form.Label>Title</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Enter size title"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        required
                    />
                </Form.Group>
                <Form.Group controlId="formPrice">
                    <Form.Label>Price</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Enter price"
                        value={price}
                        onChange={(e) => setPrice(e.target.value)}
                        required
                    />
                </Form.Group>
                <Form.Group controlId="formStatusDesignInfoId">
                    <Form.Label>Status Design Info</Form.Label>
                    <Form.Control
                        as="select"
                        value={statusDesignInfoId}
                        onChange={(e) => setStatusDesignInfoId(e.target.value)}
                        required
                    >
                        <option value="">Select Status Design Info</option>
                        {statusDesignInfos.length > 0 ? (
                            statusDesignInfos.map((info) => (
                                <option key={info.id} value={info.id}>
                                    {info.cat_id} - {info.orientation_title} {/* Adjust to show meaningful data */}
                                </option>
                            ))
                        ) : (
                            <option disabled>No Status Design Info Available</option>
                        )}
                    </Form.Control>
                </Form.Group>
                {errorMessage && <p className="text-danger">{errorMessage}</p>}
                <Button variant="primary" className='mt-2' type="submit">
                    Add Size
                </Button>
            </Form>

            {/* Display Sizes */}
            <h2 className="mt-5">Available Sizes</h2>
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Title</th>
                        <th>Price</th>
                        <th>Status Design Info ID</th>
                        <th>Created At</th>
                        <th>Updated At</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {sizes.map((size) => (
                        <tr key={size.id}>
                            <td>{size.id}</td>
                            <td>{size.title}</td>
                            <td>{size.price}</td>
                            <td>{size.status_design_info_id}</td>
                            <td>{new Date(size.created_at).toLocaleDateString()}</td>
                            <td>{new Date(size.updated_at).toLocaleDateString()}</td>
                            <td>
                                <Button variant="warning" onClick={() => handleOpenUpdateModal(size)}>
                                    Edit
                                </Button>{' '}
                                <Button variant="danger" onClick={() => handleDeleteSize(size.id)}>
                                    Delete
                                </Button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>

            {/* Modal for updating size */}
            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Update Size</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Form.Group controlId="formTitle">
                            <Form.Label>Title</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter size title"
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                                required
                            />
                        </Form.Group>
                        <Form.Group controlId="formPrice">
                            <Form.Label>Price</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter price"
                                value={price}
                                onChange={(e) => setPrice(e.target.value)}
                                required
                            />
                        </Form.Group>
                        <Form.Group controlId="formStatusDesignInfoId">
                            <Form.Label>Status Design Info</Form.Label>
                            <Form.Control
                                as="select"
                                value={statusDesignInfoId}
                                onChange={(e) => setStatusDesignInfoId(e.target.value)}
                                required
                            >
                                <option value="">Select Status Design Info</option>
                                {statusDesignInfos.length > 0 ? (
                                    statusDesignInfos.map((info) => (
                                        <option key={info.id} value={info.id}>
                                            {info.cat_id} - {info.orientation_title} {/* Adjust to show meaningful data */}
                                        </option>
                                    ))
                                ) : (
                                    <option disabled>No Status Design Info Available</option>
                                )}
                            </Form.Control>
                        </Form.Group>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={handleUpdateSize}>
                        Update Size
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default AddSize;
